ARROW_SIZE = 12
ANIMATION_DURATION = 200

###
# Компонент контейнер
###
App.SmPopoverComponent = Em.Component.extend
  classNames: [ 'sm-popover' ]
  classNameBindings: ['isOpened']
  isOpened: false
  sizeClass: 'medium'

###
# Компонент Target
###
App.SmPopoverTargetComponent = Em.Component.extend
  classNames: [ 'sm-popover-target' ]

  placementBinding:     'parentView.bodyComponent.placement'
  realPlacementBinding: 'parentView.bodyComponent.realPlacement'
  isOpenedBinding:      'parentView.bodyComponent.isOpened'

  isOpenedObserver: Ember.observer 'isOpened', ->
    if @get('isOpened')
      @updatePopoverPosition()

  click: (e) ->
    @set('parentView.isOpened', true)
    @updatePopoverPosition()

  viewportSelector: Em.computed.oneWay('parentView.viewportSelector')

  # Возвращает jQuery обернутный элемент рабочей области,
  # в границы которой вписывается поповер
  viewportEl: ->
    if @get('viewportSelector')
      @$().closest( @get('viewportSelector') )
    else
      Em.$( window )

  updatePopoverPosition: ->
    bodyComponent = @get('parentView.bodyComponent')

    # Проверки
    return unless bodyComponent
    return if @get('isDestroyed') or @get('isDestroying')

    $body   = bodyComponent.$('.sm-popover-body')
    $target = @$()

    x = $target.offset().left
    y = $target.offset().top
    w = $target.outerWidth()
    h = $target.outerHeight()

    return unless @get('parentView.bodyComponent').$()

    $clone = @get('parentView.bodyComponent').$().clone()
    $clone
      .show()
      .css('visibility','hidden')
      .insertAfter(@get('parentView.bodyComponent').$())
    $cloneBody = $clone.find('.sm-popover-body')

    bw = $cloneBody.outerWidth()
    bh = $cloneBody.outerHeight()

    $clone.remove()

    isOverlapped = true
    preferredPlacement = @get('placement')
    tries = 0

    $viewport = @viewportEl()

    viewportW = $viewport.width()
    viewportH = $viewport.height()

    viewportLeft = $viewport.offset()?.left || 0
    viewportTop  = $viewport.offset()?.top  || 0

    px = 0
    py = 0

    recalcPosition = ->
      switch preferredPlacement
        when 'top'
          px = x + 0.5 * w - 0.5 * bw
          py = y + 0.0 * h - 1.0 * bh - ARROW_SIZE
        when 'bottom'
          px = x + 0.5 * w - 0.5 * bw
          py = y + 1.0 * h + 0.0 * bh + ARROW_SIZE
        when 'left'
          px = x + 0.0 * w - 1.0 * bw - ARROW_SIZE
          py = y + 0.5 * h - 0.5 * bh
        when 'right'
          px = x + 1.0 * w + 0.0 * bw + ARROW_SIZE
          py = y + 0.5 * h - 0.5 * bh
        when 'left-bottom'
          px = x + 0.0 * w - 1.0 * bw - ARROW_SIZE
          py = y + 0.5 * h - 0.1 * bh

    while isOverlapped and tries++ < 3
      do recalcPosition

      if px + bw > viewportW + viewportLeft
        preferredPlacement = 'left'
      else if px < viewportLeft
        preferredPlacement = 'right'
      else if py < viewportTop
        preferredPlacement = 'bottom'
      else if py + bh > viewportTop + viewportH
        preferredPlacement = 'top'
      else
        isOverlapped = false

      do recalcPosition

    @set('realPlacement', preferredPlacement)
    @set('parentView.bodyComponent.bodyPosition', "left: #{Math.round(px)}px; top: #{Math.round(py)}px;".htmlSafe())


  didInsertElement: ->
    @get('parentView').set('targetComponent', @)
    Em.$(window).on('resize', @resizeHandler.bind(@))
    @updatePopoverPosition()

  willDestroyElement: ->
    Em.$(window).off('resize', @resizeHandler.bind(@))

  resizeHandler: ->
    Em.run.debounce(@, @updatePopoverPosition, 10)


###
# Компонент Body
###
App.SmPopoverBodyComponent = Em.Component.extend
  classNames: [ 'sm-popover-overlay' ]
  isOpenedBinding: 'parentView.isOpened'
  placement:     'top'
  realPlacement: 'top'

  placementClass: (-> "sm-popover-#{@get('realPlacement')}").property('realPlacement')
  sizeClass: (-> "sm-popover-#{@get('parentView.sizeClass')}").property('parentView.sizeClass')

  bodyPosition: ''.htmlSafe()

  hideOn: 'click'

  mouseDown: (e) ->
    return unless (@get('hideOn') is 'mousedown')
    if e.target == @$().get(0)
      @set('isOpened', false)

  click: (e) ->
    return unless (@get('hideOn') is 'click')

    if e.target == @$().get(0)
      @set('isOpened', false)
      Em.run.next @, ->
        $clicked = $(document.elementFromPoint(e.clientX, e.clientY))
        $target = @get('parentView.targetComponent').$()
        if $target != $clicked and not ($target[0] in $clicked.parents())
          $clicked.click()

  didInsertElement: ->
    @get('parentView').set('bodyComponent', @)
